module.exports = __webpack_public_path__ + "static/media/DooClearing.c10e1125.svg";